import React from "react";
import { Col, Row, NMPopup, Input } from "@neumetric/blueprint-lib/components";
import { useDispatch, useSelector } from "react-redux";
import {
  auditorActions,
  getDeactivateModelSuccess,
  getReactivateModelSuccess,
} from "../../../../store";

const CONFIG = {
  deactivate: {
    title: "Deactivate Blueprint?",
    primaryLabel: "Deactivate",
    primaryVariant: "CAUTION",
    message:
      "Deactivating the Blueprint will prevent Architects from assigning it to an organisation!",
    needsPassword: true,
  },
  reactivate: {
    title: "Reactivate Blueprint?",
    primaryLabel: "Reactivate",
    primaryVariant: "CAUTION",
    message:
      "Reactivating the Blueprint will allow Architects to assign it to organisations again!",
    needsPassword: true,
  },
};

export const ActivateDeactivatePopup = ({
  visible,
  mode,
  modelId,
  onClose,
  onSuccessNavigate,
}) => {
  const dispatch = useDispatch();
  const deactivateSuccess = useSelector(getDeactivateModelSuccess);
  const reactivateSuccess = useSelector(getReactivateModelSuccess);
  const cfg = CONFIG[mode] || CONFIG.deactivate;
  const [password, setPassword] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);

  const handleClose = React.useCallback(() => {
    setSubmitting(false);
    setPassword("");
    onClose && onClose();
  }, [onClose]);

  // success watcher based on mode
  React.useEffect(() => {
    const success =
      mode === "deactivate" ? deactivateSuccess : reactivateSuccess;

    if (!success) return;

    handleClose();
    onSuccessNavigate && onSuccessNavigate();

    if (mode === "deactivate") {
      dispatch(auditorActions.resetDeactivateModelSuccess());
    } else {
      dispatch(auditorActions.resetReactivateModelSuccess());
    }
  }, [
    mode,
    deactivateSuccess,
    reactivateSuccess,
    dispatch,
    handleClose,
    onSuccessNavigate,
  ]);

  const handleConfirm = () => {
    if (!modelId) return;
    setSubmitting(true);

    if (mode === "deactivate") {
      dispatch(
        auditorActions.deactivateModel({
          // id: [modelId],
          id: modelId,
          password: password.trim(),
        }),
      );
      return;
    } else {
      // reactivate
      dispatch(
        auditorActions.reactivateModel({
          // lib1_model_ids: [modelId],
          id: modelId,
          password: password.trim(),
        }),
      );
    }
  };

  const disablePrimary =
    submitting || (cfg.needsPassword ? password.trim().length === 0 : false);

  return (
    <NMPopup
      visible={visible}
      width={480}
      title={cfg.title}
      variant={cfg.primaryVariant}
      onModalClose={handleClose}
      actions={[
        {
          btnType: "TEXT",
          variant: cfg.primaryVariant,
          icon: "CANCEL",
          label: cfg.primaryLabel,
          loading: submitting,
          disabled: disablePrimary,
          onClick: handleConfirm,
        },
        {
          btnType: "CONTAINED",
          variant: "ACTION",
          icon: "CANCEL",
          label: "Cancel",
          disabled: submitting,
          onClick: handleClose,
        },
      ]}
    >
      <Col className="w-100">
        <span className="ff-exo2 fs-15 line-30 text-filled">{cfg.message}</span>

        {cfg.needsPassword && (
          <>
            <div className="ff-exo2 fs-12 text-filled mt-20">
              Enter your Account Password to confirm this action…
            </div>

            <Row className="w-100 mt-16" align="center">
              <Input
                typeRepresentation="TEXT"
                type="password"
                layout="horizontal"
                label="Password"
                value={password}
                onChange={(val) => setPassword(val)}
                placeholder="****************"
                classes={{
                  root: "w-100 mb-0 nm-pass-inline",
                  input: "nm-danger-outline",
                }}
              />
            </Row>
          </>
        )}
      </Col>
    </NMPopup>
  );
};
